import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex flex-col min-h-full" }
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "pt-3 font-oswald text-sm text-center" }

import IconSearch from '@/components/icons/IconSearch.vue';
import IconCheck from '@/components/icons/IconCheck.vue';

import { SelectListItem } from '@/utils/types/vehicleSearch';

import { ref, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VehicleSearchSelectList',
  props: {
    modelValue: { default: '' },
    items: {},
    name: { default: '' },
    listId: { default: '' },
    maxHeight: {},
    hasSearch: { type: Boolean, default: false },
    highlightSearch: { type: Boolean, default: false },
    isCustomListItem: { type: Boolean, default: false },
    searchFunction: { type: Function, default: undefined },
    searchPlaceholder: { default: '' },
    isObjValue: { type: Boolean, default: false },
    objValueKey: { default: '' },
    hasCheckmark: { type: Boolean, default: true }
  },
  emits: ["select-item", "update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;



/**
 * Emits
 */


const inputSearch = ref('');

// Computed
const getSearchItems = computed(() => {
  if (props.hasSearch && !!props.searchFunction) {
    return props.items.slice().filter(
      (item) => props.searchFunction(item, inputSearch.value.toString().toLowerCase()),
    );
  }
  if (props.hasSearch && inputSearch.value) {
    return props.items.slice().filter((item) => {
      return item.label.toString().toLowerCase().includes(inputSearch.value.toLowerCase());
    });
  }
  return props.items;
});

// Methods
function isSelectedItem(item: SelectListItem) {
  if (props.isObjValue) {
    return item.value[props.objValueKey] === props.modelValue[props.objValueKey];
  }
  return item.value === props.modelValue;
}

function onSelectListItem(item: SelectListItem, index: number) {
  emit('select-item', {
    ...item,
    index,
  });

  if (isSelectedItem(item)) {
    return;
  }
  emit('update:modelValue', item.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.hasSearch)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([
        'relative border-zbr-gray-700 group',
        _ctx.highlightSearch ? 'border-2' : 'border-b-2'
      ])
        }, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputSearch).value = $event)),
            class: _normalizeClass([
          'w-full placeholder:text-zbr-gray-400',
          'font-roboto-condensed-bold focus-visible:outline-none',
          'group-hover:placeholder:text-zbr-primary',
          _ctx.highlightSearch ? 'my-1 pl-1' : 'mb-2 pl-0'
        ]),
            placeholder: _ctx.searchPlaceholder,
            type: "text"
          }, null, 10, _hoisted_2), [
            [_vModelText, inputSearch.value]
          ]),
          _createElementVNode("button", {
            class: _normalizeClass([
          'absolute pl-3 border-l-2 border-zbr-gray-300',
          _ctx.highlightSearch ? 'top-1/2 transform -translate-y-1/2 right-1' : 'top-0 right-0'
        ])
          }, [
            _createVNode(IconSearch, { "class-stroke": "\n            stroke-zbr-gray-400\n            group-hover:stroke-zbr-primary\n          " })
          ], 2)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("ul", {
      id: _ctx.listId,
      class: "overflow-y-auto h-full",
      style: _normalizeStyle({
        maxHeight: _ctx.maxHeight
      })
    }, [
      (getSearchItems.value.length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(getSearchItems.value, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: `vehicleSelectList${_ctx.name}${index}`,
              class: "group relative flex flex-row items-center w-full h-11 border-b border-zbr-gray-300 px-4 text-sm hover:bg-zbr-primary/[.1] hover:cursor-pointer",
              onClick: ($event: any) => (onSelectListItem(item, index))
            }, [
              (_ctx.isCustomListItem)
                ? _renderSlot(_ctx.$slots, "list-item", {
                    key: 0,
                    item: item,
                    index: index
                  })
                : (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: _normalizeClass([
              item.value === _ctx.modelValue ? 'text-zbr-primary selected-brand' : ''
            ])
                  }, _toDisplayString(item.label), 3)),
              _createElementVNode("span", {
                class: _normalizeClass(["w-4 h-4 absolute right-6 top-1/2 -translate-y-1/2", [
              isSelectedItem(item) && _ctx.hasCheckmark ? 'block' : 'hidden'
            ]])
              }, [
                _createVNode(IconCheck, { "class-stroke": "stroke-zbr-primary" })
              ], 2)
            ], 8, _hoisted_4))
          }), 128))
        : (_openBlock(), _createElementBlock("li", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('NO-RESULT')), 1)
          ]))
    ], 12, _hoisted_3)
  ]))
}
}

})